import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { t } from '@sm/intl';
import { Box } from '@wds/box';
import { useTheme } from 'react-jss';
import { Theme } from '@wds/styles';
import COPY from '~app/pages/EnterpriseThankYou/copy';
import { HeaderTextPropsType, HeaderTypeEnum } from '../../types';
import useStyles from './useStyles';

const Text = ({ text, headerType }: HeaderTextPropsType): ReactElement => {
  const wrenchTheme = useTheme<Theme>();
  const { container, headerText, headerTextInner } = useStyles({ wrenchTheme });
  const hasText = !!`${text}`.trim();
  const allowCustomText = headerType === HeaderTypeEnum.PREMIUM;
  const resultText = hasText && allowCustomText ? text : t(COPY.THANK_YOU);

  return (
    <Box className={container} display="flex" flexJustify="center">
      {/* used <h1> instead of Typography to match marketing style */}
      <h1 data-testid="Text__Header" className={classNames(headerTextInner, allowCustomText ? headerText : '')}>
        {resultText}
      </h1>
    </Box>
  );
};

export default Text;
